import { on, _global } from '../utils/unils.js';
import { options } from './option.js';
import { SIGNMANAGE } from '../utils/enum.js';
import { Timer } from '../utils/process.js';

let _reporter = null;
let timer = null;
let REPORT_INTERVAL = 1000 * 60 * ((options === null || options === void 0 ? void 0 : options.config['poll-time']) || 5); // 默认5分钟
const reportPoolStorageKey = 'BILI_MIRROR_REPORT_POOL';
// 触发刚开始未获取到配置的情况,只执行1次等待2秒获取配置
// 可能会导致第一次延迟上报的 api还是默认的5分钟上报，后续等待 REPORT_INTERVAL更新后 符合配置预期
if (!(options === null || options === void 0 ? void 0 : options.config['poll-time'])) {
    setTimeout(() => {
        REPORT_INTERVAL = 1000 * 60 * ((options === null || options === void 0 ? void 0 : options.config['poll-time']) || 5);
    }, 1000);
}
// 更换上报方法
const changeReporterOfReportPool = (reporter) => {
    if (_reporter !== reporter)
        _reporter = reporter;
};
// 加入到上报池，相同消息做聚合
/** reportPool结构：[eventID][api]
 * {
 *    'main.mstation.DATA.successReport': {
 *      'api.bilibili.com/a/b': {
 *        count: 10,
 *        mirrorVersion: xxx
 *       },
 *      'api.bilibili.com/c/d': {
 *        count: 8,
 *        mirrorVersion: xxx
 *       },
 *    }
 *  }
 */
const addIntoReportPool = (eventID, msg, extra) => {
    var _a;
    // 匹配eventID和msg.api字段，一致的合成一个obj，同时obj.count+1
    const realApi = ((_a = msg === null || msg === void 0 ? void 0 : msg.api) === null || _a === void 0 ? void 0 : _a.split('?')[0]) || '';
    try {
        let reportPool = JSON.parse(localStorage.getItem(reportPoolStorageKey) || '{}');
        if (!reportPool[eventID]) {
            reportPool[eventID] = Object.assign(Object.assign({}, extra), SIGNMANAGE.TECH_POLYMER);
        }
        if (!reportPool[eventID][realApi]) {
            reportPool[eventID][realApi] = 1;
        }
        else {
            reportPool[eventID][realApi]++;
        }
        localStorage.setItem(reportPoolStorageKey, JSON.stringify(reportPool));
    }
    catch (err) { }
    startReportInterval();
};
// 通过聚合最终上报私参格式为
/**
 * 'main.mstation.DATA.successReport':{
 *  mirrorApiList:{'api1':2,'api2':3,'api3':4},
 *  mirrorVerion:1.4.12
 *  type:custom
 * }
 */
// 上报上报池的所有消息，并清空上报池
const clearReportPoolAndReport = () => {
    try {
        let reportPool = JSON.parse(localStorage.getItem(reportPoolStorageKey) || '{}');
        if (!Object.keys(reportPool).length)
            return;
        Object.entries(reportPool).forEach(([eventID, apiData]) => {
            _reporter['tech'](eventID, apiData);
        });
        localStorage.setItem(reportPoolStorageKey, '{}');
    }
    catch (err) { }
};
// 定时上报
const startReportInterval = () => {
    if (timer)
        return;
    timer = new Timer();
    timer.repeat(clearReportPoolAndReport, REPORT_INTERVAL);
    // 页面关闭前，清一次reportPool
    on(_global, 'beforeunload', function () {
        clearReportPoolAndReport();
        cleanUpReportPool();
    });
};
// 清空
const cleanUpReportPool = () => {
    // beforeunload事件需要上报时，需手动调用pbreport的flush方法触发一次上报
    _reporter && _reporter.flush && _reporter.flush();
    timer === null || timer === void 0 ? void 0 : timer.clear();
};

export { addIntoReportPool, changeReporterOfReportPool, cleanUpReportPool, clearReportPoolAndReport, startReportInterval };
